"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GetParentObject;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.find.js");
require("core-js/modules/web.dom-collections.iterator.js");
/**
 * Hook to get parent object from key and value
 * default key ="link" and value="location.pathname"
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * to return back parent object using key-value matched combination from an multidimensional array
 */
function GetParentObject(jsonArray, keyToBeSearched, valueToBeSearched) {
  const keyinArr = keyToBeSearched ? keyToBeSearched : 'link';
  const valueinArr = valueToBeSearched ? valueToBeSearched : location.pathname;
  const checkThisItem = (currentItem, key, value) => {
    const keyValuePairs = Object.entries(currentItem || {});
    if (keyValuePairs) {
      for (const [k, v] of keyValuePairs) {
        if (k === key && value.includes(v)) return true; //this will return true if both key and value exists
        if (Array.isArray(v)) {
          //if item has any array/submenu
          for (const f of v) {
            if (checkThisItem(f, key, value)) return true;
          }
        }
        if (typeof v === 'object' && v !== null) {
          if (checkThisItem(v, key, value)) return true;
        }
      }
    } else {
      return false;
    }
  };
  return jsonArray && jsonArray.find(item => (item === null || item === void 0 ? void 0 : item.keyinArr) === valueinArr ? item : checkThisItem(item, keyinArr, valueinArr));
}